import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';

const CampaignEditButton = ({
  onEditCampaign,
  campaignStatus
}) => {
  const isCampaignDeleted = !!campaignStatus && (campaignStatus === 'ARCHIVED' || campaignStatus === 'REMOVED');
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.deletedCampaignEditTooltip"
    }),
    disabled: !isCampaignDeleted,
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      onClick: onEditCampaign,
      size: "small",
      disabled: isCampaignDeleted,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCampaignButton"
      })
    })
  });
};

export default CampaignEditButton;